// frontend/components/notifications/index.ts
export { NotificationsBell } from "./NotificationsBell";
